import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { GraphqlService } from '@base/services/graphql.service';

import {
    Animco,
    AnimcoList,
    AnimcoRawData,
    RecommendedPhoneInfos,
} from '@app/modules/product-details/product-animco/product-animco.interface';

import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductAnimcoService {
    constructor(
        private graphqlService: GraphqlService,
        private httpClient: HttpClient,
        @Inject(DOCUMENT) private document: Document,
    ) {}

    public getAnimcoForProduct(slug: string, typeParcours: string): Observable<AnimcoRawData> {
        const baseSlug: string = 'all-phones';
        const query = `{
            getAnimFicheProduit {
                items @SPL(query: "Slug IN ['${slug}', '${baseSlug}']"){
                    Slug
                    anim_animco_list {
                        items @SPL(query:"'${typeParcours}' IN parcours\") @sort(by:"order" order:"asc" )
                        {
                            type
                            promo_code
                            text
                            tooltip
                            end_date
                            start_date
                        }
                    }
                    banner_animco_list { items@SPL(query: "'${typeParcours}' IN parcours") { display_sticker sticker_value text} }
                }
            }
            getFicheProduitBonusReprise {
                items {
                    forfait_bonus_reprise
                }
        }
        }`;
        const headers = new HttpHeaders().set(
            'X-Graphql-Scope',
            this.document.defaultView.ConfigInitial?.graphQL?.animcoScope,
        );

        return this.graphqlService.query(query, headers);
    }

    public filterAnimcoList(productAnimcoList: AnimcoList[], slug, baseSlug, attribute): [] {
        return (
            productAnimcoList.filter((a) => a.Slug === slug)[0]?.[attribute]?.items ||
            productAnimcoList.filter((a) => a.Slug === baseSlug)[0]?.[attribute]?.items ||
            []
        );
    }

    public filterAnimcoByDate(productAnimcoList: Animco[]): Animco[] {
        const currentDate = new Date();
        return productAnimcoList.filter((obj) => {
            if (!obj.start_date && !obj.end_date) {
                return true;
            }

            const startDateObj = obj.start_date ? new Date(obj.start_date) : null;
            const endDateObj = obj.end_date ? new Date(obj.end_date) : null;

            if (!obj.end_date) {
                return currentDate >= startDateObj;
            }
            return currentDate >= startDateObj && currentDate <= endDateObj;
        });
    }

    public getRecommendedPhoneModalInfos(planGencode: string): Observable<RecommendedPhoneInfos> {
        const url = `${this.document.defaultView['ConfigInitial']?.graphQL?.bannersUrl}/milano/modal/${planGencode}`;
        const headers = new HttpHeaders()
            .set('X-Source', this.document.defaultView['ConfigInitial']?.oauth?.xSource)
            .set('Content-Type', 'application/json');

        return this.httpClient.get<RecommendedPhoneInfos>(url, { headers });
    }
}
